
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import ScrollToTop from './components/ScrollToTop';
import MobileStickyBar from './components/feature/MobileStickyBar';

import CookieConsent from './components/feature/CookieConsent';

function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <AppRoutes />
        </main>
        <Footer />
        <MobileStickyBar />
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}

export default App;
